const Collection = {
  init: function () {
    if (!document.querySelector(".template-collection")) return

    this.initAccordion()
    this.initQuickBuy()
  },

  initAccordion: function () {
    if (!document.querySelector(".collectionAccordion")) return

    const accordionToggle = document.querySelector(
      ".collectionAccordion__toggle"
    )
    const accordionList = document.querySelector(".collectionAccordion__list")

    accordionToggle.addEventListener("click", () => {
      if (accordionToggle.classList.contains("closed")) {
        accordionList.style.maxHeight = `${accordionList.scrollHeight}px`
        setTimeout(() => {
          accordionList.style.maxHeight = "none"
        }, 210)
      } else {
        accordionList.style.maxHeight = `${accordionList.scrollHeight}px`
        setTimeout(() => {
          accordionList.style.maxHeight = "0px"
        }, 10)
      }

      accordionToggle.classList.toggle("closed")
    })

    document
      .querySelectorAll(".collectionAccordion__itemQuestion")
      .forEach((el) => {
        el.addEventListener("click", () => {
          el.parentNode.classList.toggle("open")
        })
      })

    window.addEventListener("resize", () => {
      if (!accordionToggle.classList.contains("closed")) {
        accordionList.style.maxHeight = `${accordionList.scrollHeight}px`
      }
    })
  },

  initQuickBuy: function () {
    if (!document.querySelector(".quick-buy-button")) return

    document.querySelectorAll(".quick-buy-button").forEach((el) => {
      el.addEventListener("click", () => {
        this.addToCart(el.getAttribute("data-variant-id"))
      })
    })
  },

  addToCart: function (variantId) {
    let formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
    .then((response) => {
      $(".cart_item_count").text(window.ned_cart.item_count + 1)
      return response.json()
    })
    .catch((error) => {
      console.error("Error:", error)
    })
  },
}

export default Collection
